module.exports = "https://static-www.niulinkcloud.com/_next/static/media/shipinhao.e28c053c32108809b7b468e26bbf984b.png";